import client from './client';
import query from './query';

export default function checkLoggedUser() {
  return client.query({ query });
}
